module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-detail/modal-mail-sender/modal-mail-sender.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-detail/modal-mail-sender/modal-mail-sender.component.sass
// module chunks = main